import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import styles from '../../Login.module.scss';
import { useTranslation } from 'react-i18next';

const { Button, Box, Title } = vp;

type TwoFactorAuthenticationInfoProps = {
  handleContinue: () => void;
};

type FC = FunctionComponent<TwoFactorAuthenticationInfoProps>;
const TwoFactorAuthenticationInfo: FC = (props: TwoFactorAuthenticationInfoProps) => {
  const { handleContinue } = props;
  const { t } = useTranslation('translations', { keyPrefix: 'Login.MFA.Info' });

  return (
    <Box flx="col">
      <Box mb="sm" flx="col" ai="center" height="auto">
        <Title title={t('title')} bold size="xsm" />
      </Box>
      <div className={styles.loginDescription}>{t('instructionOne')}</div>
      <div className={styles.loginDescription}>{t('instructionTwo')}</div>
      <ul className={styles.authenticatorList}>
        <li>Google Authenticator</li>
        <li>Microsoft Authenticator</li>
        <li>Authy</li>
        <li>LastPass Authenticator</li>
        <li>Duo Mobile</li>
        <li>Apple Two-Factor Authentication</li>
      </ul>
      <Box jc="fe" flx="col" height="auto">
        <Button
          id="enable-2-fa"
          type="button"
          label={t('enableButton')}
          size="xlg"
          textSize={1}
          onClick={() => {
            handleContinue();
          }}
        />
      </Box>
    </Box>
  );
};
export default TwoFactorAuthenticationInfo;
